import { updateLayout } from './updateLayout';

/**
 * Utility function to load layout configuration for a user from the window.apiResponse
 * Extracts user email, country, and creation date then calls updateLayout
 *
 * @param setIsSpecialUser - State setter for special user flag
 * @param setSectionOrder - State setter for section order array
 * @param userType - Type of user ('DDG' or 'NonDDG') for error logging
 */
export async function loadLayoutForUser(
  setIsSpecialUser: (value: boolean) => void,
  setSectionOrder: (value: string[]) => void,
  setIsVariantD: (value: boolean) => void,
  userType: 'DDG' | 'NonDDG'
): Promise<void> {
  try {
    const userCountry =
      (globalThis as any).apiResponse?.recommendations?.[0]?.multi_field?.geometry?.properties?.[0]
        ?.country || '';

    const userRole = userType === 'DDG' ? 'grower' : 'seller';

    await updateLayout(
      setIsSpecialUser,
      setSectionOrder,
      setIsVariantD,
      userCountry,

      userRole
    );
  } catch (error) {
    console.error(`Error loading layouts for ${userType} user:`, error);
  }
}
